import type { KeyboardEvent } from 'react'

/**
 * Makes a non-button element work as a button: reachable with Tab and activated with Enter or Space,
 * like a click. For a click target that wraps other content and so cannot itself be a `<button>`.
 *
 * @example
 * <Stack {...pressableProps(() => onEdit(id))} aria-label={t('cart.edit_aria', { name })}>…</Stack>
 */
export const pressableProps = (onPress: () => void) => ({
  role: 'button' as const,
  tabIndex: 0,
  onClick: onPress,
  onKeyDown: (event: KeyboardEvent) => {
    if (event.target !== event.currentTarget) return
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onPress()
  },
})

/** The focus ring a pressable shows when reached with the keyboard. */
export const pressableFocusSx = {
  '&:focus-visible': { outline: '2px solid currentColor', outlineOffset: '2px' },
} as const
